import { ChevronDownIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const SelectComponent = ({ name, value, onChange, disabled = false, children, ...props }) => {
  const handleSelectChange = e => {
    if (!onChange) return;
    onChange({ target: { name, value: e.target.value, type: 'select' } });
  };

  const baseClasses = `
    appearance-none w-full p-2 pr-8 border rounded-md shadow-sm text-sm
    focus:outline-none focus:ring-1 focus:border-green-800 focus:ring-green-500
  `;
  const cursorClass = disabled
    ? 'cursor-not-allowed bg-gray-100 text-gray-500 border-gray-300'
    : 'cursor-pointer';

  return (
    <div className="relative">
      <select
        {...props}
        id={props?.id || name}
        name={name}
        disabled={disabled}
        className={`${baseClasses} ${cursorClass} ${props.className || ''}`}
        value={value !== undefined ? value.toString() : ''}
        onChange={handleSelectChange}
      >
        {children}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
        <ChevronDownIcon className="w-4 h-4 text-gray-400" />
      </div>
    </div>
  );
};

export default SelectComponent;

SelectComponent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string
};
